<template>
<div class="navbar-fixed-content" style="padding-top:70px;">
  <div class="new_index newcontrain">
    <div class="step">
      <a href="/">师资培训</a>
      &gt; {{classData.name}}
    </div>
    <div class="info">
      <img :src="classData.logo" class="banlogo" />
      <div class="ft">
        <div class="name">{{classData.name}}</div>
        <div class="num">
          <div class="span1">
            <img src="Images/icon-scale.png" />
            <span>
              <span id="studentNum"> {{classData.scale}}</span> 人
            </span>
          </div>
          <div class="span3">
            <img src="Images/icon-type.png" />
            <span> {{classData.category}}</span>
          </div>
          <div class="span2">
            <img src="Images/icon-timelong.png" />
            <span> {{classData.timelong}} 天</span>
          </div>
        </div>
        <div class="statue">已参加</div>
        <div class="opr">
          <div class="shareModel" style="position:static">
            <span class="qaaCollection00" @click="collectClass()">
              <span :class="[classData.isCollect?'ischoosed':'','qaaCollection']"></span>
              <span :class="[!classData.isCollect?'ischoosed':'','qaaCollection2']" >取消收藏</span>
             <span
                :class="[classData.isCollect?'ischoosed':'','qaaCollection1']" 
              >收藏</span>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="kc_box">
      <h2 class="tab-title">
        <span>
          <a :class="[curTab==1?'cur':'']" @click="tabClick(1)">讲师团队</a>
          <a :class="[curTab==2?'cur':'']" @click="tabClick(2)">培训目标</a>
          <a :class="[curTab==3?'cur':'']" @click="tabClick(3)">课程目录</a>
          <!-- <a :class="[curTab==4?'cur':'']" @click="tabClick(4)">录播课程</a> -->
          <a :class="[curTab==5?'cur':'']" @click="tabClick(5)">直播课程</a>
          <a :class="[curTab==6?'cur':'']" @click="tabClick(6)">培训风采</a>
          <a :class="[curTab==7?'cur':'']" @click="tabClick(7)">资料下载</a>
        </span>
      </h2>
      <div class="kc_box1">
        <!-- 讲师团队-->
        <div class="list" v-show="curTab==1">
          <div class="teacherList">
            <div class="u-item"  v-for="item in classTeacher">
              <span class="userIco">
                <img :src="item.photoUrl" />
              </span>
              <span class="u-right">
                <span class="span1">
                  {{item.name}}
                  <!-- <span>·</span> -->
                  
                </span>
                <span class="span2">{{item.schoolName}}</span>
              </span>
              <div class="desc">{{item.experience}}</div>
            </div>
            <div class="nodata" v-if="classTeacher==null||classTeacher.length==0">
              <span class="nodata-img"></span>
              <span class="nodata-txt">没有找到数据</span>
            </div>
          </div>
        </div>
        <!-- 培训目标-->
        <div class="list"  v-show="curTab==2">
          <div class="trainPoint" style="padding: 20px 20px;">
            <div class="ck-content" v-html="classData.fullIntroduce"></div>
          </div>
        </div>
        <!-- 培训目录 -->
        <div class="list"  v-show="curTab==3">
          <div class="trainSection" style="padding: 20px 20px;">
            <div class="ck-content" v-html="classData.courseIntroduce"></div>
          </div>
        </div>
        <!-- 直播课程-->
        <div class="list"  v-show="curTab==5">
          <div class="liveList">
            <div class="dateoption" >
              <span @click="changeDate(liveitem.time)" :class="[currentDate==liveitem.time || (currentDate==''&& index==0)?'active':'']" v-for="(liveitem,index) in classLivesGroupByDate">{{liveitem.time}}</span>
            </div>
            <div v-for="(liveitem,index) in classLivesGroupByDate" v-show="currentDate==liveitem.time || (currentDate==''&& index==0)">
              <div class="zb-item" v-for="item in liveitem.subList" >
                <div class="img-left">
                  <div class="logo-div1"></div>
                  <img class="logo" :src="item.logo" />
                </div>
                <div class="info-right">
                  <span class="title p-span" :title="item.title">{{item.title}}</span>
                  <span class="desc p-span" :title="item.content" style="height: 60px;max-height: 60px;white-space: normal;"><pre style="background:none; color:#999;
                    border: 0;    line-height: 21px;    font-family: '微软雅黑';    white-space: pre-line;    font-size: 14px;">{{item.content}}</pre></span>
                  <span class="num p-span" style=" margin-top: 8px;">
                    <span class="teacher" style="margin-left:0">{{item.presenter}}</span>
                    <hr />
                    <img src="Images/time.jpg" />
                    <span>{{item.startTimeS}} 至 {{item.endTimeS}}</span>
                  </span>
                  <span class="opr p-span" >
                    <button
                      style="margin-top:2px"
                      v-if="item.state ==2 && item.hasBackPlay==1"
                      class="finished"
                      data-url
                      @click="playback(item)"
                    >观看回放</button>
                    <button   style="margin-top:2px" v-else-if="item.state == 2 && item.hasBackPlay==0">未录制回放</button>
                    <button   style="margin-top:2px" v-else-if="item.state == 0 " data-url @click="start(item)">未开始</button>
                    <button   style="margin-top:2px" v-else data-url @click="start(item)" class="start">进入直播</button>
                  </span>
                </div>
              </div>
            </div>
            <!-- <div class="nodata" v-if="classLives==null||classLives.length==0">
              <span class="nodata-img"></span>
              <span class="nodata-txt">没有找到数据</span>
            </div> -->
          </div>
        </div>
        <!-- 成果上传-->
        <div class="list"  v-show="curTab==6">
          <div class="ConsquentList">
            <div class="fitem" style="height: 40px;color: #333;  font-weight: bold;" v-if="classResults.length>0">
              <span class="filename" style=" text-indent: 32px;width: 530px;">文档名称</span>
              <span class="filesize">大小</span>
              <span class="time">时间</span>
              <!-- <span class="user">姓名</span> -->
              <!-- <span class="school">单位</span> -->
            </div>
            <div class="fitem" v-for="item in classResults">
              <span class="filename" :title="item.fileName" style="width: 530px;">
                <span class="ftype pdf"></span>
                {{item.fileName}}
              </span>
              <span class="filesize">{{item.fileSize|fileSizeFormat()}}</span>
              <span class="time">{{item.createTime|dateFormat()}}</span>
              <!-- <span class="user">{{item.uploadBy}}</span> -->
              <!-- <span class="school">{{item.school}}</span> -->
              <a class="btn_down" @click="downFile(item)" >预览</a>
            </div>
            <div class="nodata" v-if="classResults.length==0">
              <span class="nodata-img"></span>
              <span class="nodata-txt">没有找到数据</span>
            </div>
          </div>
          <div class="opr1" v-if="classResultsPage.total>1">
            <span class="my-course-page">
              <span class="page">{{classResultsPage.page+1}}/{{classResultsPage.total}}</span>
              <a class="page-prev prev" @click="pagePrev(0)"></a>
              <a class="page-next next" @click="pageNext(0)"></a>
            </span>
          </div>
        </div>
        <!-- 资料下载 -->
        <div class="list"  v-show="curTab==7">
          <div class="fileList">
            <div class="fitem" style=" height: 40px;color: #333;  font-weight: bold;" v-if="classFiles.length>0">
              <span class="filename" style="text-indent: 32px;">文档名称</span>
              <span class="filesize">大小</span>
              <span class="time">时间</span>
              <span class="courseName">隶属课程</span>
            </div>
            <div class="fitem" v-for="item in classFiles">
              <span class="filename" :title="item.fileName">
                <span class="ftype pdf"></span>
                {{item.fileName}}
              </span>
              <span class="filesize">{{item.fileSize|fileSizeFormat()}}</span>
              <span class="time">{{item.creationTimeS}}</span>
              <span class="courseName">{{item.courseName}}</span>
              <a class="btn_down" @click="downFile(item)" >下载</a>
            </div>
            <div class="nodata" v-if="classFiles.length==0">
              <span class="nodata-img"></span>
              <span class="nodata-txt">没有找到数据</span>
            </div>
            <div class="opr1" v-if="classFilesPage.total>1">
            <span class="my-course-page">
              <span class="page">{{classFilesPage.page+1}}/{{classFilesPage.total}}</span>
              <a class="page-prev prev" @click="pagePrev(3)"></a>
              <a class="page-next next" @click="pageNext(3)"></a>
            </span>
          </div>
          </div>
        </div>
      </div>
    </div>
    <div class="desc_box">
      <div class="desc-item">
        <h2>培训班级简介</h2>
        <div class="desc">{{classData.baseSummary}}</div>
      </div>

      <div class="desc-item">
        <h2>班级通知</h2>
        <div class="noticeList">
          <div class="nitem" v-if="classNotices[currentIndex]!=undefined" >
            <span v-if="classNotices[currentIndex].content.length>35 && !classNotices[currentIndex].active">{{classNotices[currentIndex].content.substring(0,35)}}...</span>
            <span v-else>{{classNotices[currentIndex].content}}</span>
            <a @click="showAllTXt(currentIndex)" v-if="!classNotices[currentIndex].active">展开</a>
            <a @click="showAllTXt(currentIndex)" v-if="classNotices[currentIndex].active" class="shou">收起</a>
          </div>
        </div>
      </div>

      <div class="desc-item">
        <h2>学员风采</h2>

        <div class="stulist" >
            <div v-for="item in classStudent">
                <h2 :class="[item.show?'down':'','schooltitle']" @click="showStudentList(item)" >
                    <span class="icon"></span>
                    <span class="sname" :title="item.schoolName">{{item.schoolName}}</span>
                    <span class="snum">({{item.subList.length}})</span>
                    <i></i>
                </h2>
                <div class="stulist_div" v-show="item.show" >
                    <span class="stuitem" v-for="stu in item.subList">
                    <img :src="stu.photoUrl" />
                    <span class="name">{{stu.name}}</span>
                    </span>
                </div>
            </div>
        
        </div>
      </div>
    </div>
  </div>
</div>

</template>

<script>
//import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import comFun from "@/common/common";
import store from '@/store/store'
export default {
  name: "classDetail",
  components: {},
  data() {
    return {
      currentDate:'',
      classId: 0,
      curTab:1,
      classData: {},
      classTeacher: [],
      classStudent: [],
      classLives: [],
      classLivesGroupByDate:[],
      classCourses: [],
      classFiles: [],
      classResults: [],
      classNotices:[],
      classResultsPage: {
        page: 0,
        pageSize: 6,
        total: 0,
        classId: 0,
        resType:1
      },
      classFilesPage: {
        page: 0,
        pageSize: 10,
        total: 0,
        classId: 0,
      },
      // classLivesPage: {
      //   page: 0,
      //   pageSize: 6,
      //   total: 0,
      //   classId: 0
      // },
      classCoursesPage: {
        page: 0,
        pageSize: 6,
        total: 0,
        classId: 0
      },
      currentIndex:0, // 当前通知索引
      interval:undefined,
      schoolList: [ 
      "001.北京工业职业技术学院","002.唐山工业职业技术学院","003.山西工程职业学院","004.辽宁机电职业技术学院","005.长春职业技术学院","006.南京工业职业技术学院","007.苏州工业职业技术学院","008.常州机电职业技术学院","009.温州职业技术学院","010.浙江机电职业技术学院","011.淄博职业学院","012.山东工业职业学院","013.河南工业职业技术学院","014.武汉职业技术学院","015.武汉船舶职业技术学院","016.湖南工业职业技术学院","017.柳州职业技术学院","018.重庆工程职业技术学院","019.四川工程职业技术学院","020.陕西工业职业技术学院","021.常州信息职业技术学院","022.九江职业技术学院","023.山东科技职业学院","024.郑州铁路职业技术学院","025.湖北职业技术学院","026.广东科学技术职业学院","027.深圳信息职业技术学院","028.重庆工商职业学院","029.成都职业技术学院","030.北京信息职业技术学院","031.天津电子信息职业技术学院","032.浙江工商职业技术学院","033.山东商业职业技术学院","034.广州番禺职业技术学院","035.长沙航空职业技术学院","036.成都航空职业技术学院","037.西安航空职业技术学院","038.天津市职业大学","039.邢台职业技术学院","040.辽宁省交通高等专科学校",
      "041.长春汽车工业高等专科学校","042.上海交通职业技术学院","043.南京交通职业技术学院","044.江西交通职业技术学院","045.湖南汽车工程职业学院","046.广东交通职业技术学院","047.重庆工业职业技术学院","048.四川交通职业技术学院","049.贵州交通职业技术学院","050.石家庄职业技术学院","051.内蒙古建筑职业技术学院","052.黑龙江建筑职业技术学院","053.浙江建设职业技术学院","054.绍兴职业技术学院","055.安庆职业技术学院","056.日照职业技术学院","057.黄河水利职业技术学院","058.广西建设职业技术学院","059.重庆建筑工程职业学院","060.四川建筑职业技术学院","061.陕西铁路工程职业技术学院","062.无锡职业技术学院","063.南京信息职业技术学院","064.湖南铁道职业技术学院","065.深圳职业技术学院","066.广东机电职业技术学院","067.重庆电子工程职业学院","068.天津现代职业技术学院","069.辽宁石化职业技术学院","070.吉林工业职业技术学院","071.江苏农牧科技职业学院","072.常州工程职业技术学院","073.宁波职业技术学院","074.广东轻工职业技术学院","075.广东食品药品职业学院","076.重庆医药高等专科学校","077.兰州石化职业技术学院","078.天津轻工职业技术学院","079.河北工业职业技术学院","080.山东理工职业学院",
      "081.湖北水利水电职业技术学院","082.湖南电气职业技术学院","083.广西电力职业技术学院","084.重庆电力高等专科学校","085.酒泉职业技术学院","086.黑龙江农业经济职业学院","087.江苏经贸职业技术学院","088.无锡商业职业技术学院","089.浙江经贸职业技术学院","090.浙江金融职业学院","091.杭州职业技术学院","092.河南经贸职业学院","093.广西经贸职业技术学院","094.昆明冶金高等专科学校","095.北京财贸职业学院","096.天津交通职业学院","097.河北交通职业技术学院","098.辽宁经济职业技术学院","099.浙江经济职业技术学院","100.江西旅游商贸职业学院","101.山东交通职业学院","102.武汉交通职业学院","103.湖南现代物流职业技术学院","104.广西职业技术学院","105.北京劳动保障职业学院","106.北京社会管理职业学院","107.天津医学高等专科学校","108.长春医学高等专科学校","109.苏州卫生职业技术学院","110.聊城职业技术学院","111.滨州职业学院","112.长沙民政职业技术学院","113.乐山职业技术学院","114.岳阳职业技术学院","115.徐州幼儿师范高等专科学校","116.金华职业技术学院","117.合肥幼儿师范高等专科学校","118.福建幼儿师范高等专科学校","119.泉州幼儿师范高等专科学校","120.四川幼儿师范高等专科学校",
      "121.西昌民族幼儿师范高等专科学校","122.和田师范专科学校","123.其他单位","124.中国教育国际交流协会","125.海南","126.青海","127.宁夏","128.西藏","129.新疆兵团","130.同济大学","131.天津职业技术师范大学","132.山东理工大学","133.清华大学","134.天津中德应用技术大学","135.西安交通大学","136.北京理工大学","137.吉林工程技术师范学院","138.扬州大学","139.天津大学","140.陕西科技大学","141.西北农林科技大学","142.哈尔滨商业大学","143.东南大学","144.江苏理工学院","145.吉林农业大学","146.重庆师范大学","147.河北师范大学"
       ]
    };
  },
  created() {
    this.currentDate = this.$options.filters['dateFormat2'](new Date())

    this.classId = this.$route.query.id;
    
    this.classResultsPage.classId = this.classId;
    this.classCoursesPage.classId = this.classId;
    this.classFilesPage.classId=this.classId;
    // this.classLivesPage.classId = this.classId;
    
    comFun.getclassDetail(this.classId).then(res => {
      this.classData = res;
    });
    comFun.getclassTeachers(this.classId).then(res => {
      this.classTeacher = res;
    });
    //培训风采
    comFun.getClassNotice(this.classId).then(res=>{
      if(res.items!=undefined && res.items.length>0) this.classNotices = res.items
    })
    comFun.getclassStudents(this.classId).then(res => {
      this.classStudent = res
      this.GroupBySchool()
      this.classStudent = this.classStudent.sort(function (a, b) {
        var str1 = a.num
        var str2 = b.num
         return str1 - str2
      });
    });
    // this.getclassCourseList();
    this.getclassLiveList();
    this.getclassResultList();
    this.getclassFileList();

    this.interval = setInterval(() => {
        if(this.currentIndex == this.classNotices.length-1) this.currentIndex = 0
        else{   this.currentIndex ++        }
    },6000)
  },
  filters: {
    fileSizeFormat: function(size) {
        var _s=(size/1024/1024).toFixed(2)
      return _s+"M";
    },
    dateFormat: function(dateStr) {
      var dt = new Date(dateStr);
      var yy = dt.getFullYear();
      var mm = (dt.getMonth() + 1).toString().padStart(2, "0");
      var dd = dt
        .getDate()
        .toString()
        .padStart(2, "0");
      return yy + "-" + mm + "-" + dd;
    },
    dateFormat2: function(dateStr) {
      var dt = new Date(dateStr);
      // var yy = dt.getFullYear();
      var mm = (dt.getMonth() + 1).toString().padStart(2, "0");
      var dd = dt
        .getDate()
        .toString()
        .padStart(2, "0");
      return  mm + "-" + dd;
    }
  },
  methods: {
    showAllTXt(index){
      if(this.classNotices[index].active == undefined)   this.$set(this.classNotices[index], 'active', 'true')
      else this.$set(this.classNotices[index],'active',!this.classNotices[index].active)
      if(this.classNotices[index].active) clearInterval(this.interval)
      else { 
        this.interval = setInterval(() => {
          if(this.currentIndex == this.classNotices.length-1) this.currentIndex = 0
          else{   this.currentIndex ++        }
        }, 6000)
      }
    },
    getclassResultList() {
      comFun.getclassResult(this.classResultsPage).then(res => {
        this.classResults = res.items;
        this.classResultsPage.total =parseInt( res.totalCount/ this.classResultsPage.pageSize);
       
        if (res.totalCount %  this.classResultsPage.pageSize > 0) {
          this.classResultsPage.total++;
        }
      });
    },
    getclassFileList() {
      comFun.getclassFiles(this.classFilesPage).then(res => {
        this.classFiles = res.items;
        this.classFilesPage.total =parseInt( res.totalCount/ this.classFilesPage.pageSize);
       
        if (res.totalCount %  this.classFilesPage.pageSize > 0) {
          this.classFilesPage.total++;
        }
      });
    },
    getclassCourseList() {
      comFun.getclassCourses(this.classCoursesPage).then(res => {
        this.classCourses = res.items;
        this.classCoursesPage.total = parseInt(res.totalCount / this.classCoursesPage.pageSize);
        if (res.totalCount % this.classCoursesPage.pageSize > 0) {
          this.classCoursesPage.total++;
        }
      });
    },
    getclassLiveList() {
      var classLivesPage = {
        page: 0,
        pageSize: 100,      
        classId: this.classId
      }
      comFun.getclassLives(classLivesPage).then(res => {
        this.classLives = res.items;
        this.GroupByDate()
        //如果没有匹配的日期，清空 currentDate
        if(!this.classLivesGroupByDate.some(item => item.time == this.currentDate)){
          this.currentDate =''
        }
        
      });
    },
    pagePrev(t) {
      if (t == 0) {
        if (this.classResultsPage.page > 0) {
          this.classResultsPage.page--;
          this.getclassResultList();
        }
      }
      // if (t == 1) {
      //   if (this.classLivesPage.page > 0) {
      //     this.classLivesPage.page--;
      //     this.getclassLiveList();
      //   }
      // }
      if (t == 2) {
        if (this.classCoursesPage.page > 0) {
          this.classCoursesPage.page--;
          this.getclassCourseList();
        }
      }
      if (t == 3) {
        if (this.classFilesPage.page > 0) {
          this.classFilesPage.page--;
          this.getclassFileList();
        }
      }
    },
    pageNext(t) {
      if (t == 0) {
        if (this.classResultsPage.page+1 < this.classResultsPage.total) {
          this.classResultsPage.page++;
          this.getclassResultList();
        }
      }
      // if (t == 1) {
      //   if (this.classLivesPage.page+1 < this.classLivesPage.total) {
      //     this.classLivesPage.page++;
      //     this.getclassLiveList();
      //   }
      // }
      if (t == 2) {
        if (this.classCoursesPage.page +1< this.classCoursesPage.total) {
          this.classCoursesPage.page++;
          this.getclassCourseList();
        }
      }
      if (t == 3) {
        if (this.classFilesPage.page+1 < this.classFilesPage.total) {
          this.classFilesPage.page++;
          this.getclassFileList();
        }
      }
    },
    collectClass(){
         var _user = store.state.userInfo;
        if (_user == null) {
            store.dispatch('setShowLogin', true) // 显示登录框
            return false;
        }
        //debugger
        if(this.classData.isCollect)
        {
             comFun.delcollectClass(this.classId).then(res => {
                 this.classData.isCollect=false;
             });
        }else
        {
             comFun.collectClass(this.classId).then(res => {
                  this.classData.isCollect=true;
             });
        }

    },
    tabClick(index){
        this.curTab=index
    },
    showStudentList(item){

        if(item.show) item.show=false;
        else item.show=true;
    },
    start(item) {
      comFun.start(item);
    },
    playback(item) {
      comFun.playback(item);
    },
    clickLiveUrl(item) {
      if (item.state == 2 && item.hasBackPlay) comFun.playback(item);
      else if (item.state == 0 || item.state == 1) {
        comFun.start(item);
      }
    },
    clickKcUrl(item) {
      //if()
       this.$router.push({
        name: 'CourseDetail',
        query: {
          id: item.id
        }
       })
    },
    GroupByDate(){ // 按照日期分组
      let newArr = [];
      this.classLives.forEach((item, i) => {
        let index = -1;
        //some用来查找数组中是否存在某个值
        let isExists = newArr.some((newItem, j) => {
          if (this.$options.filters['dateFormat2'](item.startDate) == newItem.time) {
            index = j;
            return true;
          }
        })
        if (!isExists) {
          newArr.push({
            time: this.$options.filters['dateFormat2'](item.startDate),
            subList: [item]
          })
        } else {
          newArr[index].subList.push(item);
        }
        this.classLivesGroupByDate = newArr
      })
    },
    GroupBySchool(){
      let newArr = [];
      this.classStudent.forEach((item, i) => {
        let index = -1;
        var strArr = item.schoolName.split('.')
        var str_num = strArr[0]
        if(item.schoolName.indexOf('.') == -1 || str_num > 147) { 
          str_num = 123
        }
        //some用来查找数组中是否存在某个值
        let isExists = newArr.some((newItem, j) => {
          if (str_num == newItem.num) {
            index = j;
            return true;
          }
        })
        if (!isExists) {
          newArr.push({
            num: str_num,
            subList: item.classStudents,
            schoolName:this.schoolList[str_num-1],
            show:false
          })
        } else {
          newArr[index].subList = newArr[index].subList.concat(item.classStudents);
        }
        this.classStudent = newArr
      })
    },
    changeDate(time){
      this.currentDate = time
    },
    validLogined() { //验证是否登录
         var _user = store.state.userInfo;
        if (_user == null) {
            store.dispatch('setShowLogin', true) // 显示登录框
            return false;
        }
        return true
    },
    async downFile(item) { // 下载文档
        if (!this.validLogined()) return false
        var output =await comFun.IsJoinClass(this.classId)
        if (!output) {
          var msg = {
            type: 'error',
            text: '对不起，您没有权限访问！'
          }
          this.$store.dispatch('setMsg', msg)
        } else {
          window.open(item.fileUrl, '_blank')
        }

      },
   },
  
};
</script>

<style lang="scss" scoped>
</style>

